import React from "react";
import Moment from "react-moment";
import {
  ListTodo,
  Tag,
  Users,
  UserCheck,
  Clock,
  FileText,
} from "lucide-react";
import "./ViewUserTask.css";

const sectionTitleStyle = {
  fontSize: "12px",
  fontWeight: 700,
  color: "#94A3B8",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  borderBottom: "1px solid #EEF2F6",
  paddingBottom: "8px",
  marginBottom: "14px",
};

const labelStyle = {
  display: "block",
  fontSize: "12px",
  fontWeight: 700,
  color: "#2E6DA4",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: "4px",
};

const valueStyle = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#0F2D42",
  lineHeight: 1.5,
};

const fieldGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: "18px",
};

const iconStyle = { marginRight: "4px", verticalAlign: "-1px" };

const orNA = (value) => {
  if (value === null || value === undefined) return "NA";
  if (typeof value === "string" && value.trim() === "") return "NA";
  return value;
};

const UserTaskInfo = ({ taskData }) => {
  if (!taskData) {
    return (
      <div className="utv-page">
        <div className="utv-card utv-empty">No task data available.</div>
      </div>
    );
  }

  const taskTypeLabel =
    taskData.task_type === 0 || taskData.task_type === "0"
      ? "Activity"
      : "Notification";

  const assignTypeLabel =
    taskData.assign_type === 0 || taskData.assign_type === "0"
      ? "Group"
      : "Users";

  const assignTaskLabel = (() => {
    const v = taskData.assign_task;
    if (v === null || v === undefined || v === "") return "NA";
    return v === 0 || v === "0" ? "Anyone" : "Everyone";
  })();

  const memberList = Array.isArray(taskData.userTaskMapList)
    ? taskData.userTaskMapList
    : [];

  return (
    <div className="utv-page">
      <div
        className="utv-card utv-card-body"
        style={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        {/* ── Task Details ── */}
        <div>
          <div style={sectionTitleStyle}>Task Details</div>
          <div style={fieldGridStyle}>
            <div>
              <label style={labelStyle}>
                <ListTodo size={11} style={iconStyle} />
                Task Name
              </label>
              <div style={valueStyle}>{orNA(taskData.name)}</div>
            </div>
            <div>
              <label style={labelStyle}>
                <Tag size={11} style={iconStyle} />
                Task Type
              </label>
              <div style={valueStyle}>{taskTypeLabel}</div>
            </div>
            <div>
              <label style={labelStyle}>
                <Clock size={11} style={iconStyle} />
                Created On
              </label>
              <div style={valueStyle}>
                {taskData.createdOn ? (
                  <Moment format="DD/MM/YYYY, hh:mm a">
                    {taskData.createdOn}
                  </Moment>
                ) : (
                  "NA"
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ── Assignment ── */}
        <div>
          <div style={sectionTitleStyle}>Assignment</div>
          <div style={fieldGridStyle}>
            <div>
              <label style={labelStyle}>
                <Users size={11} style={iconStyle} />
                Assign Type
              </label>
              <div style={valueStyle}>{assignTypeLabel}</div>
            </div>
            <div>
              <label style={labelStyle}>
                <UserCheck size={11} style={iconStyle} />
                Assign Task
              </label>
              <div style={valueStyle}>{assignTaskLabel}</div>
            </div>
          </div>
        </div>

        {/* ── Description ── */}
        <div>
          <div style={sectionTitleStyle}>
            <FileText size={11} style={iconStyle} />
            Description
          </div>
          <div
            style={{
              ...valueStyle,
              fontWeight: 500,
              background: "#EBF4FA",
              border: "1px solid #E2E8F0",
              borderRadius: "10px",
              padding: "12px 14px",
              whiteSpace: "pre-wrap",
            }}
          >
            {orNA(taskData.description)}
          </div>
        </div>

        {/* ── Assigned Members ── */}
        {memberList.length > 0 && (
          <div>
            <div style={sectionTitleStyle}>Assigned Members</div>
            <div style={{ overflowX: "auto" }}>
              <table className="utv-members-table">
                <thead>
                  <tr>
                    <th>Assigned To</th>
                    <th>Status</th>
                    <th>Assigned On</th>
                  </tr>
                </thead>
                <tbody>
                  {memberList.map((m) => (
                    <tr key={m.id}>
                      <td>{orNA(m.assigned_to)}</td>
                      <td>{orNA(m.status)}</td>
                      <td>
                        {m.created_on ? (
                          <Moment format="DD/MM/YYYY, hh:mm a">
                            {m.created_on}
                          </Moment>
                        ) : (
                          "NA"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserTaskInfo;
